import React from 'react';
import './skills.css';
import { MacbookScroll } from '../ui/MacbookScroll';

const Skills: React.FC = () => {
  return (
    <section className="skills section" id="skills">
      <div className="section__header">
        <h2 className="section__title">Skills</h2>
        <span className="section__subtitle">My technical expertise</span>
      </div>

      <div className="skills__macbook-container">
        <MacbookScroll
          src={`${process.env.PUBLIC_URL}/assets/homepage.png`}
          showGradient={true}
        />
      </div>
    </section>
  );
};

export default Skills; 
